// Cars.com icon - official logo with swooshes
// Brand color: #65299D

export function CarsComIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 255.1 100" width={24} height={24} style={{ stroke: 'none' }}>
            <g fill="#65299D">
                <path d="M186.4,5.9c-18.7-3.3-39.3-3.6-61.3-2.3c-33.1,2-63.8,9.1-86.4,20.5C18.3,34.3,7,46.7,7.7,58
                    c0.4,6.3,3.9,11.9,11.2,17.4C6.7,67.6,0,58.7,0,50c0-12,12.7-24.3,35-33.8C59.6,5.8,92.4,0,127.5,0C148.4,0,168.4,2,186.4,5.9"/>
                <path d="M255.1,50c0,12-12.7,24.3-35,33.8c-24.6,10.5-57.5,16.2-92.6,16.2c-20.9,0-41-2-59-5.9
                    c18.7,3.4,39.3,3.8,61.2,2.4c33.1-2.1,63.8-9.3,86.4-20.6c20.4-10.2,31.8-22.6,31-33.9c-0.4-6.3-3.8-11.8-11-17.4
                    C248.4,32.5,255.1,41.3,255.1,50z"/>
                <path d="M36.2,49.5c0-6.8,5.1-12.1,12.1-12.1c4.5,0,8.4,2.4,10.2,5.9l-5.1,3c-0.9-1.9-2.9-3.1-5.2-3.1
                    c-3.5,0-6.1,2.6-6.1,6.3c0,3.6,2.6,6.2,6.1,6.2c2.4,0,4.3-1.1,5.3-3l5.1,2.9c-2,3.6-5.9,5.9-10.3,5.9
                    C41.4,61.6,36.2,56.3,36.2,49.5z"/>
                <path d="M84.6,38v22.9h-5.9v-2.7c-1.6,2.1-4.1,3.3-7.5,3.3c-6.1,0-11.1-5.3-11.1-12.1s5-12.1,11.1-12.1
                    c3.3,0,5.8,1.3,7.5,3.3V38H84.6z M78.4,49.5c0-3.8-2.7-6.4-6.4-6.4c-3.6,0-6.3,2.6-6.3,6.4s2.7,6.4,6.3,6.4
                    C75.7,55.9,78.4,53.3,78.4,49.5L78.4,49.5z"/>
                <path d="M100.9,37.6v6.6c-3.1-0.4-7,1-7,5.8v10.9h-5.9V38H94V42C95.2,38.9,98,37.6,100.9,37.6z"/>
                <path d="M121.5,54.2c0,4.9-4.3,7.3-9.2,7.3c-4.6,0-8-1.9-9.6-5.4l5.1-2.9c0.6,1.9,2.2,3,4.5,3c1.9,0,3.2-0.6,3.2-2
                    c0-3.3-11.8-1.5-11.8-9.6c0-4.7,4-7.3,8.7-7.3c3.7,0,6.9,1.7,8.7,4.9l-5,2.7c-0.7-1.5-2-2.3-3.7-2.3c-1.5,0-2.7,0.6-2.7,1.9
                    C109.7,47.9,121.5,45.8,121.5,54.2z"/>
                <path d="M126.6,55.5c1.6-0.3,3.2,0.7,3.6,2.3c0.3,1.6-0.7,3.2-2.3,3.6c-1.6,0.3-3.2-0.7-3.6-2.3c0,0,0,0,0,0
                    C123.9,57.5,125,55.9,126.6,55.5C126.6,55.5,126.6,55.5,126.6,55.5z"/>
                <path d="M131.6,49.5c0-6.8,5.1-12.1,12.1-12.1c4.5,0,8.4,2.4,10.2,5.9l-5.1,3c-0.9-1.9-2.9-3.1-5.2-3.1
                    c-3.5,0-6.1,2.6-6.1,6.3c0,3.6,2.6,6.2,6.1,6.2c2.4,0,4.3-1.1,5.3-3l5.1,2.9c-2,3.6-5.9,5.9-10.3,5.9
                    C136.7,61.6,131.6,56.3,131.6,49.5z"/>
                <path d="M155.5,49.5c0-6.8,5.4-12.1,12.1-12.1s12.1,5.3,12.1,12.1s-5.4,12.1-12.1,12.1S155.5,56.3,155.5,49.5z
                     M173.8,49.5c0-3.7-2.7-6.3-6.2-6.3c-3.5,0-6.2,2.6-6.2,6.3c0,3.7,2.7,6.3,6.2,6.3C171.1,55.8,173.8,53.2,173.8,49.5z"/>
                <path d="M216.7,46.8v14.1h-5.9V47.2c0-2.7-1.4-4.3-3.8-4.3c-2.6,0-4.3,1.7-4.3,5.2v12.9h-5.9V47.2
                    c0-2.7-1.4-4.3-3.8-4.3c-2.5,0-4.3,1.7-4.3,5.2v12.9h-5.9V38h5.9v2.4c1.3-1.9,3.4-3.1,6.4-3.1c2.8,0,4.9,1.2,6.2,3.3
                    c1.4-2.1,3.7-3.3,6.8-3.3C213.2,37.4,216.7,41.1,216.7,46.8z"/>
            </g>
        </svg>
    );
}
